import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { PopupLayoutComponent } from "app/admin/confirmation-popup/popup-layout/popup-layout.component";
import { MandateConstants } from "app/admin/create-mandate/mandate-constant";
import { RequestState, RequestStateEnum } from "app/common/http/RequestState";
import { ToasterService, ToasterType } from "app/services/toaster.service";
import { UserService } from "app/services/user.service";
import { NgxOtpInputComponent, NgxOtpInputComponentOptions } from "ngx-otp-input";

@Component({
    selector: "app-otp-modal",
    templateUrl: "./otp-modal.component.html",
    styleUrls: ["./otp-modal.component.scss"],
    standalone: false
})
export class OtpModalComponent implements OnInit {
  @ViewChild("ngxotp") ngxotp: NgxOtpInputComponent;
  @ViewChild("modal") modal: PopupLayoutComponent;

  cardOtpResponse: any;
  submitRequestState: RequestState;

  fetchUsageSettings: RequestState;

  @Input()
  onVerify: EventEmitter<any> = new EventEmitter();

  @Input()
  dismissModal: EventEmitter<any> = new EventEmitter();

  @Input()
  mobile: number;

  @Input()
  companyId: string;

  interval = null;

  timeLeft: number = 60;

  form: FormGroup = new FormGroup({
    otp: new FormControl("", [
      Validators.required,
      Validators.pattern(/^\d{6}$/),
    ]),
  });

  //TODO: ADD THE CLASSED TO COMPONENT ITSELF
    // classList: {
    //   container: "custom-container-otp",
    //   inputBox: "custom-input-box-otp",
    //   input: "custom-input-otp",
    // },

  otpInputConfig: NgxOtpInputComponentOptions = {
    otpLength: 6,
    autoFocus: true, 
    autoBlur: true, 
    hideInputValues: false,
    showBlinkingCursor: true,
    ariaLabels: ['OTP Input'],
    inputMode: 'numeric'
  };

  constructor(
    private toasterService: ToasterService,
    private userService: UserService
  ) {
    this.fetchUsageSettings = RequestState.init();
    this.submitRequestState = RequestState.init();
  }

  ngOnInit(): void {
    this.fetchUsageSettings.pending();
    this.userService.generateOtpForSwitchingAccount(this.mobile,this.companyId).subscribe(
      (res) => {
        this.cardOtpResponse = res.payload;
        this.startTimer();
        this.fetchUsageSettings.completed();
      },
      (error) => {
        const errorJson = error["error"];
        if (errorJson != null && errorJson["response_message"] != null) {
          this.openSnackBar(
            error[MandateConstants.error][MandateConstants.responseMessage],
            ToasterType.ERROR
          );
        } else {
          this.openSnackBar("Something went Wrong", ToasterType.ERROR);
        }
        this.fetchUsageSettings.completed();
      }
    );
    this.dismissModal.subscribe((item) => {
      this.modal.dismiss();
    });
  }

  patchOtpValue(value: string) {
    const otp = value == null ? '' : String(value);
    this.form.patchValue({ otp });
  }

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.clearTimer();
      }
    }, 1000);
  }

  clearTimer() {
    clearInterval(this.interval);
    this.interval = null;
  }

  maskPhoneNumber(number: number): string {
    if (!number) return;
    return number
      .toString()
      .replace(/([0-9]{2})([0-9]{5,6})([0-9]{2})/, function ($0, $1, $2, $3) {
        return $1 + $2.replace(/\d/g, "x") + $3;
      });
  }

  onResendOtp(): void {
    this.userService.generateOtpForSwitchingAccount(this.mobile,this.companyId).subscribe(
      () => {
        this.form.reset();
        this.ngxotp.reset();
        this.openResendOTPSnackBar();
        this.timeLeft = 60;
        this.startTimer();
      },
      (error) => {
        const errorJson = error["error"];
        if (errorJson != null && errorJson["response_message"] != null) {
          this.openSnackBar(
            error[MandateConstants.error][MandateConstants.responseMessage],
            ToasterType.ERROR
          );
        } else {
          this.openSnackBar("Something went Wrong", ToasterType.ERROR);
        }
      }
    );
  }

  openResendOTPSnackBar() {
    this.toasterService.showToaster(
      `OTP has been sent to Your registered Mobile Number`,
      ToasterType.INFO
    );
  }
  openSnackBar(message: string, type) {
    this.toasterService.showToaster(message, type);
  }

  formActionRequestState(): RequestStateEnum {
    return this.submitRequestState.state;
  }
}
